<template>
    <div class="vacancies-card">
        <vue-headful :title="$t('vacancies')" />
        <div
            id="todo-app"
            class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden"
        >
            <vs-sidebar
                class="items-no-padding"
                parent="#todo-app"
                :click-not-close="clickNotClose"
                :hidden-background="clickNotClose"
                v-model="isSidebarActive"
            >
                <!-- ФИЛЬТРЫ -->
                <ListFilters :sidebarToggle="toggleSidebar" ref="ListFilters" @closesidebar="toggleSidebar" :schedules="schedules"/>
            </vs-sidebar>

            <div
                :class="{ 'sidebar-spacer': clickNotClose }"
                class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content"
            >
                <div
                    class="infinite_header flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light"
                >
                    <!-- TOGGLE SIDEBAR BUTTON -->
                    <feather-icon
                        class="md:inline-flex lg:hidden ml-4 mr-2 lg:mr-4 cursor-pointer"
                        icon="MenuIcon"
                        @click.stop="toggleSidebar(true)"
                    />
                    <vs-input
                        class="px-2 lg:px-5 py-2 w-full"
                        icon="search"
                        icon-after="true"
                        :placeholder="$t('search_by_name')"
                        @change="getFiltered()"
                        v-model="serch_by_name"
                    />
                    <div class="flex">
<!--                       <vx-tooltip class="m-2" :text="$t('my_responds')">-->
<!--                            <vs-button-->
<!--                                ref="loadableButton"-->
<!--                                id="my-res-button"-->
<!--                                class="vs-con-loading__container w-full mr-1 lg:mr-4 px-1"-->
<!--                                @click="goMyResponds()"-->
<!--                                >-->
<!--                                 <feather-icon icon="MessageCircleIcon" />-->
<!--                            </vs-button>-->
<!--                        </vx-tooltip>-->
                    </div>

                </div>
                <VuePerfectScrollbar
                    id="div-with-loading"
                    class="vs-con-loading__container scroll-area empl_scroll"
                    :settings="settings"
                >
                    <div>
                        <ul v-if="vacancies.length">
                            <li
                                class="todo_todo-item cursor-pointer px-2 lg:px-5 pt-2 pb-2 lg:pt-3 lg:pb-3"
                                v-for="(item, index) in vacancies"
                                :style="[
                                    { transitionDelay: index * 0.1 + 's' },
                                ]"
                                :key="index"
                                v-if="item.accessibility"
                            >
                                <ListItem :item="item" />
                            </li>
                        </ul>

                        <!-- Выводим сообщение если данных нет -->
                        <div class="mt-4 ml-5 mr-5" v-if="!vacancies.length">
                            <vs-alert active="true">
                                {{ $t("no_data_text") }}
                            </vs-alert>
                        </div>

                        <div class="ml-6" v-if="has_site">
                            <h4>
                                {{ $t("vacancies_are_provided") }}
                                <a style="cursor: pointer" @click="openLink">
                                    {{ name_site }}
                                </a>
                            </h4>
                        </div>
                    </div>

                    <!-- В этот див выводил лоадер -->
                    <!-- <div id="infinite_loader" class="vs-con-loading__container"></div>

                        <div class="edited_dummy"></div> -->
                </VuePerfectScrollbar>
            </div>
        </div>
        <!-- <my-cv-popup
                v-bind="MyCVPopup"
                @close="closeMyCVsPopup"
                @delete="deleteCV"/> -->
        <!-- <my-cv-popup v-bind="MyCVPopup" @close="closeMyCVsPopup" /> -->
        <div class="mobile_dummy"></div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
//import MyCVs from "./Popups/MyCVs";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ListFilters from "./ListFilters.vue";
import ListItem from "./ListItem.vue";

export default {
    data() {
        return {
            serch_by_name: "",
            isSidebarActive: true,
            loading: false,
            emptyMessage: false,
            clickNotClose: true,
            infiniteStatus: true,
            settings: {
                maxScrollbarLength: 120,
                wheelSpeed: 0.6,
            },
            MyCVPopup: {
                active: false,
                data: null,
            },
            has_site: false,
            name_site: "",
            schedules:[]
        };
    },
    watch: {
        windowWidth() {
            this.setSidebarWidth();
        },
    },
    components: {
        //"my-cv-popup": MyCVs,
        VuePerfectScrollbar,
        ListFilters,
        ListItem,
    },
    computed: {
        windowWidth() {
            return this.$store.state.windowWidth;
        },
        ...mapGetters({
            vacancies: "employment/getVacancies",
            schedules: "employment/getSchedules",
        }),
    },
    methods: {
        ...mapActions({
            getVacancies: "employment/getVacancies",
            getVacanciesFiltered: "employment/getVacanciesFiltered",
            getSchedules: "employment/getSchedules",
            getEducationProgram: "organizations/getEducationProgram",
            getJobDescriptions: "employment/getJobDescriptions"
        }),
        openLink() {
            window.open(this.getValidUrl(this.name_site), "_blank");
        },
        async getSettings() {
            try {
                const res = (await this.$http("employment/vacancies/sites/")).data[0];

                if(res) {
                    this.has_site = res.has_site;
                    this.name_site = res.name;
                }
            } catch(e) {

            }
        },
        goMyResponds() {
            this.$router.push({
                name: "employment-my_responds",
            });
        },
        goMyResumes(){
            this.$router.push({
                name: "my-resumes",
            });
        },
        getValidUrl(url = "") {
            let RegExp = /^((ftp|http|https):\/\/)?(www\.)?([A-Za-zА-Яа-я0-9]{1}[A-Za-zА-Яа-я0-9\-]*\.?)*\.{1}[A-Za-zА-Яа-я0-9-]{2,8}(\/([\w#!:.?+=&%@!\-\/])*)?/;

            if (RegExp.test(url)) {
                let newUrl = window.decodeURIComponent(url);
                newUrl = newUrl.trim().replace(/\s/g, "");
                if (/^(:\/\/)/.test(newUrl)) {
                    return `https${ newUrl }`;
                }
                if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
                    return `https://${ newUrl }`;
                }
                return newUrl;
            } else {
                this.$vs.notify({
                    title: this.$t("error"),
                    text: this.$t("invalid_link"),
                    color: "danger",
                });
            }
        },
        closeMyCVsPopup() {
            this.MyCVPopup.active = false;
        },
        // async deleteCV(item){
        //     await this.deleteStudentCV(item.uid)
        // },
        async showMyCVsPopup() {
            this.$vs.loading({
                container: "#my-cvs-button",
                scale: 0.45,
            });
            await this.getstudentCVs();
            this.$vs.loading.close("#my-cvs-button > .con-vs-loading");
            this.MyCVPopup.data = this.studentCVs;
            this.MyCVPopup.active = true;
        },
        toggleSidebar(value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return;
            this.isSidebarActive = value;
        },
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false;
            } else {
                this.isSidebarActive = this.clickNotClose = true;
            }
        },
        async getFiltered() {
            this.$vs.loading({
                container: "#filter-div-loading",
                scale: 0.6,
            });
            let obj = {
                schedule: "",
                required_education: "",
                job: this.serch_by_name,
            };
            await this.getVacanciesFiltered(obj);
            this.$vs.loading.close("#filter-div-loading > .con-vs-loading");
        },
        async init() {
            this.$vs.loading({
                container: "#div-with-loading",
                scale: 0.6,
            });
            await this.getVacancies();
            //await this.getSchedules();
            // await this.getJobDescriptions();
            let schedules = [];
            await this.getSchedules().then(function(res){
                for(var i = 0; i < res.length; i++){
                    res[i].key = i.toString();
                    res[i].text = res[i].name_ru;
                }
                schedules = res;
            }, function(err){});
            this.schedules = schedules;

            // console.log(this.vacancies);
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        },
    },
    mounted() {
        this.getSettings();
        this.init();
        this.setSidebarWidth();
    },
};


</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
#infinite_loader {
    padding: 20px 0;
    .con-vs-loading {
        background: transparent;
    }
}
.empl_scroll{
    height: calc(100% - 56.39px);
}
.infinite_header {
    min-height: 56.4px;
}
@media only screen and (max-width: 800px) {
    .mobile_dummy{
        padding-top: 50px;
    }
}
</style>
